import React, { useState } from 'react';
import {
  Box,
  Typography,
  TextField,
  InputLabel,
  Pagination,
} from '@mui/material';
import Grid2 from '@thirdparty-framework/mui/material/Grid';
import DocumentCard from './DocumentCard';

export default function DocumentGallery({
  data,
  onCardClick = () => undefined,
  showSearch = false,
  showPagination = false,
  itemsPerRow = 2,
  paginationState,
  totalItems,
  onPaginationChange = () => undefined,
}) {
  const [search, setSearch] = useState('');
  const pageItems = data;

  // Calculate total pages based on totalItems and pageSize
  const totalPages = paginationState?.pageSize
    ? Math.ceil(totalItems / paginationState.pageSize)
    : 1;

  return (
    <Box sx={{ mt: 1, pb: 2 }}>
      {showSearch && (
        <Grid2 container spacing={2} alignItems="center" sx={{ mb: 2 }}>
          <Grid2 xs={12} md={12}>
            <InputLabel sx={{ mb: 2 }}>Search</InputLabel>
            <TextField
              fullWidth
              placeholder="Search by title, tag or description"
              value={search}
              onChange={e => {
                setSearch(e.target.value);
              }}
              size="small"
            />
          </Grid2>
        </Grid2>
      )}

      <Grid2 container spacing={2}>
        {pageItems.map(doc => (
          <Grid2 key={doc.slugUrl} item xs={12} md={12 / itemsPerRow}>
            <DocumentCard onClick={onCardClick} document={doc} />
          </Grid2>
        ))}

        {pageItems.length === 0 && (
          <Grid2 item xs={12}>
            <Typography variant="body2">No documents found.</Typography>
          </Grid2>
        )}
      </Grid2>

      {showPagination && (
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
          <Pagination
            count={totalPages}
            page={paginationState?.pageIndex}
            onChange={(_, v) =>
              onPaginationChange({
                pageIndex: v,
                pageSize: paginationState?.pageSize,
              })
            }
            color="primary"
          />
        </Box>
      )}
    </Box>
  );
}
